import axios from 'axios';
import errorHandler from './errorHandler.js';

const handleError = errorHandler().handleError;

const testAlias = 'Email-Designer-Test-Delivery';

const bytesToBase64 = bytes => {
  const binString = Array.from(bytes, x => String.fromCodePoint(x)).join('');
  return btoa(binString);
};

export default function (baseUrl) {
  const url = baseUrl || 'http://localhost:4242';

  const conf = token => {
    return {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
  };

  async function retrieveUserDbs(accessToken, customer, page = 0) {
    try {
      const path = `${url}/customers/${customer}/subscriber-sources?page=${page}`;
      const response = await axios.get(path, conf(accessToken));
      if (response.data.last) {
        return response.data.content;
      }
      const nextPage = await retrieveUserDbs(accessToken, customer, page + 1);
      return [...response.data.content, ...nextPage];
    } catch (error) {
      throw handleError(error);
    }
  }

  async function retrieveFields(accessToken, customer, userDb, page = 0) {
    try {
      const path = `${url}/customers/${customer}/subscriber-sources/${userDb}/fields?page=${page}`;
      const response = await axios.get(path, conf(accessToken));
      if (response.data.last) {
        return response.data.content;
      }
      const nextPage = await retrieveFields(
        accessToken,
        customer,
        userDb,
        page + 1
      );
      return [...response.data.content, ...nextPage];
    } catch (error) {
      throw handleError(error);
    }
  }

  async function getTestDelivery(accessToken, customer) {
    try {
      const path = `${url}/customers/${customer}/deliveries?type=IMMEDIATE&alias=${testAlias}`;
      const response = await axios.get(path, conf(accessToken));
      if (response.data.empty) {
        return undefined;
      }
      return response.data.content[0];
    } catch (error) {
      throw handleError(error);
    }
  }

  async function sendMessage(accessToken, customer, payload, extraInfo) {
    const extraInfoString = bytesToBase64(
      new TextEncoder().encode(JSON.stringify(extraInfo))
    );
    try {
      const path = `${url}/customers/${customer}/immediate/dispatches?extraInfo=${extraInfoString}`;
      const response = await axios.post(path, payload, conf(accessToken));
      return response;
    } catch (error) {
      throw handleError(error);
    }
  }

  return {
    retrieveUserDbs,
    retrieveFields,
    getTestDelivery,
    sendMessage
  };
}
